import { render, staticRenderFns } from "./CadastroDetailList.vue?vue&type=template&id=2a7f487a&"
import script from "./CadastroDetailList.vue?vue&type=script&lang=js&"
export * from "./CadastroDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports